import { memo } from "react";

function NextStopCompliancePriorityMarker({ stopSequence, textColor, color }) {
  const shiftLeft = stopSequence && stopSequence < 10 ? 0 : -3;
  return (
    <svg
      width="35"
      height="35"
      viewBox="0 0 30 30"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      {/* Generator: Sketch 52.5 (67469) - http://www.bohemiancoding.com/sketch */}
      <desc>Created with Sketch.</desc>
      <g
        id="Map-interactions"
        stroke="none"
        strokeWidth={1}
        fill="none"
        fillRule="evenodd"
      >
        <g id="Stops-on-map-" transform="translate(1.000000, 1.000000)">
          <path
            d="M13.7125339,7.50054975 C13.958556,11.1357611 16.8642389,14.041444 20.4994503,14.2874661 C20.8244859,15.2999889 21,16.3794977 21,17.5 C21,23.2989899 16.2989899,28 10.5,28 C4.70101013,28 0,23.2989899 0,17.5 C0,11.7010101 4.70101013,7 10.5,7 C11.6205023,7 12.7000111,7.1755141 13.7125339,7.50054975 Z"
            id="Combined-Shape"
            stroke={textColor}
            fill={color}
          />
          <circle
            id="Oval-15"
            stroke={textColor}
            fill={color}
            cx={22}
            cy={6}
            r={6}
          />
          <g
            id="Time_glass"
            transform="translate(6.000000, 13.000000)"
            fill={textColor}
            fillRule="nonzero"
          >
            <path
              d="M7.8125,1.35521766 L1.4375,1.35521766 C1.1875,1.35521766 1.0012962,1.02305885 1.0012962,0.677608829 C1.0012962,0.330488281 1.17035042,0 1.4375,0 L7.8125,0 C7.93961203,0 8.21748797,0.307960855 8.21748797,0.677608829 C8.21748797,0.997536913 8.08249198,1.22340652 7.8125,1.35521766 Z"
              id="Shape"
            />
            <path
              d="M1.4375,10 C1.1875,10 0.977350105,9.6067813 0.977350105,9.3567813 C0.977350105,9.1067813 1.1875,8.71356261 1.4375,8.71356261 L7.8125,8.71356261 C8.0625,8.71356261 8.26164049,9.1067813 8.26164049,9.3567813 C8.26164049,9.66644563 8,10 7.8125,10 L1.4375,10 Z"
              id="Shape"
            />
            <path
              d="M2.1875,10 C1.9375,10 1.75,9.8125 1.75,9.5625 L1.75,7.5 C1.75,6.4375 2.3125,5.5 3.25,5 C2.3125,4.5 1.75,3.5625 1.75,2.5 L1.75,0.4375 C1.75,0.1875 1.9375,0 2.1875,0 L7.0625,0 C7.3125,0 7.5,0.1875 7.5,0.4375 L7.5,2.5 C7.5,3.5625 6.9375,4.5 6,5 C6.9375,5.5 7.5,6.4375 7.5,7.5 L7.5,9.5625 C7.4375,9.8125 7.25,10 7,10 L2.1875,10 Z M6.3,8.5125 L6.3,7.13125 C6.3,6.440625 5.70172871,5.79581073 5.06422871,5.53018573 C4.90485371,5.53018573 4.85172871,5.37081073 4.85172871,5.21143573 L4.85172871,4.78643573 C4.85172871,4.62706073 4.90485371,4.46768573 5.06422871,4.41456073 C5.70172871,4.14893573 6.3,3.51875 6.3,2.828125 L6.3,1.5 L2.9,1.5 L2.9,2.88125 C2.9,3.571875 3.59041493,4.21182283 4.22791493,4.47744783 C4.33416493,4.47744783 4.44041493,4.63682283 4.44041493,4.79619783 L4.44041493,5.27432283 C4.44041493,5.38057283 4.33416493,5.53994783 4.22791493,5.59307283 C3.59041493,5.85869783 2.9,6.49375 2.9,7.184375 L2.9,8.5125 L6.3,8.5125 Z"
              id="Shape"
            />
          </g>
          <text
            id={2}
            fontFamily="OpenSans-SemiBold, Open Sans"
            fontSize={8}
            fontWeight={500}
            fill={textColor}
          >
            <tspan x={20 + shiftLeft} y={9}>
              {stopSequence}
            </tspan>
          </text>
        </g>
      </g>
    </svg>
  );
}

export default memo(NextStopCompliancePriorityMarker);
